module.exports = __webpack_public_path__ + "img/photo-16.0f9c85e2.jpg";